export default {
  POINT_CLOUD: 0,
  POLYLINE: 1,
  WIREFRAME: 2,
  WIREFRAME_RANDOM_SUB: 3,
  FACE_OPAQUE_PLAIN: 4,
  DEBUG_GEOMETRY: 5,
  FACE_LIGHT: 6,
}
